import { useCallback, useContext, useEffect, useState } from 'react'

import { Button } from '~/components/Button'
import { LoginForm } from '~/forms/PersonalTrainer/Login'
import { PersonalTrainerSignUpForm } from '~/forms/PersonalTrainerSignUpForm'
import { authenticationAtom } from '~/modules/authentication/data'
import { PersonalTrainerSignInDTO } from '~/modules/authentication/schema'
import { authenticatePersonalTrainer } from '~/modules/authentication/services'
import { PersonalTrainerSingUpDTO } from '~/modules/personalTrainer/schema'
import { signUpPersonalTrainer } from '~/modules/personalTrainer/services'
import { useAtom } from '~/observers/jotai'

import { subscriptionsCheckoutContext } from '../..'
import { IdentifiedCustomer } from './IdentifiedCustomer'

export const CustomerData: React.FC = () => {
  const { accumulateFormData } = useContext(subscriptionsCheckoutContext)
  const [session] = useAtom(authenticationAtom)
  const [formType, setFormType] = useState<'login' | 'signup'>('login')

  const handleSignIn = useCallback(
    async (payload: PersonalTrainerSignInDTO) => {
      if (payload) {
        await authenticatePersonalTrainer(payload)
      }
    },
    [],
  )

  const handleSignUp = useCallback(
    async (payload: PersonalTrainerSingUpDTO) => {
      const data = await signUpPersonalTrainer(payload)
      if (data) {
        await authenticatePersonalTrainer({
          documentNumber: data.documentNumber,
          password: payload.password!,
        })
      }
    },
    [],
  )

  useEffect(() => {
    if (session) {
      accumulateFormData({ customerId: session.user.id })
    } else {
      accumulateFormData({ customerId: undefined })
    }
  }, [session, accumulateFormData])

  return session ? (
    <IdentifiedCustomer />
  ) : (
    <div className='flex flex-col gap-3 items-end'>
      <div>
        {formType === 'login' ? (
          <Button mode='blank' onClick={() => setFormType('signup')}>
            Não tenho cadastro no GPA STÚDIO PRO
          </Button>
        ) : (
          <Button mode='blank' onClick={() => setFormType('login')}>
            Voltar ao login
          </Button>
        )}
      </div>
      <div className='w-full'>
        {formType === 'login' ? (
          <LoginForm buttonLabel='PRÓXIMO PASSO' onSubmit={handleSignIn} />
        ) : (
          <PersonalTrainerSignUpForm
            buttonLabel='PRÓXIMO PASSO'
            onSubmit={handleSignUp}
          />
        )}
      </div>
    </div>
  )
}
